(function () {
  'use strict';

  function injectLuxurySwatchStyles() {
    var style = document.getElementById('bollide-sticky-atc-luxury-swatch-css') || document.createElement('style');
    style.id = 'bollide-sticky-atc-luxury-swatch-css';
    style.textContent = [
      '#sticky-atc{background:rgba(255,255,255,.94)!important;border-top:1px solid rgba(5,6,9,.08)!important;box-shadow:0 -18px 50px rgba(5,6,9,.07)!important;backdrop-filter:saturate(180%) blur(18px);-webkit-backdrop-filter:saturate(180%) blur(18px)}',
      '#sticky-atc .sticky-atc-inner{max-width:1320px!important;min-height:84px!important;padding:10px 32px!important;display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:28px!important}',
      '#sticky-atc .sticky-atc-left{display:grid!important;grid-template-columns:54px minmax(0,1fr)!important;align-items:center!important;gap:16px!important;min-width:0!important}',
      '#sticky-atc .sticky-atc-left img{width:54px!important;height:54px!important;object-fit:cover!important;border-radius:8px!important;background:#f7f6f2!important;box-shadow:inset 0 0 0 1px rgba(5,6,9,.06)!important}',
      '#sticky-atc .sticky-atc-left>div{display:grid!important;grid-template-columns:minmax(170px,240px) minmax(180px,1fr) auto!important;grid-template-areas:"title variants price"!important;align-items:center!important;column-gap:22px!important;min-width:0!important}',
      '#sticky-atc .sticky-atc-title{grid-area:title!important;font-size:14px!important;line-height:1.2!important;font-weight:650!important;letter-spacing:0!important;color:#050609!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}',
      '#sticky-atc .sticky-atc-price{grid-area:price!important;font-size:14px!important;line-height:1!important;color:rgba(5,6,9,.64)!important;white-space:nowrap!important;margin:0!important}',
      '#sticky-atc .sticky-atc-variant-stack{grid-area:variants!important;display:grid!important;grid-template-columns:230px minmax(0,1fr)!important;grid-template-areas:"summary selector" ". fit"!important;align-items:center!important;column-gap:14px!important;row-gap:3px!important;min-width:0!important;margin:0!important}',
      '#sticky-atc .sticky-atc-selected-summary{grid-area:summary!important;font-size:12px!important;line-height:1.2!important;color:rgba(5,6,9,.62)!important;white-space:nowrap!important;width:230px!important;min-width:0!important;max-width:230px!important;overflow:hidden!important;text-overflow:ellipsis!important}',
      '#sticky-atc .sticky-atc-selector-group{grid-area:selector!important;display:flex!important;align-items:center!important;gap:8px!important;min-width:0!important}',
      '#sticky-atc .sticky-atc-fit-note{grid-area:fit!important;margin:0!important;font-size:11px!important;line-height:1.2!important;color:rgba(5,6,9,.56)!important;white-space:nowrap!important}',
      '#sticky-atc .sticky-atc-fit-note strong{font-weight:650!important;color:rgba(5,6,9,.72)!important}',
      '#sticky-atc .sticky-atc-variant-row{display:flex!important;align-items:center!important;gap:8px!important;margin:0!important;min-width:0!important;flex:0 0 auto!important}',
      '#sticky-atc .sticky-atc-variant{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important}',
      '#sticky-atc .sticky-atc-color-picker{display:flex!important;align-items:center!important;gap:8px!important;flex-wrap:nowrap!important;min-width:0!important}',
      '#sticky-atc .sticky-atc-color-swatch{position:relative;width:28px!important;height:28px!important;min-width:28px!important;padding:0!important;border:1px solid rgba(5,6,9,.18)!important;border-radius:6px!important;background:var(--bollide-sticky-swatch,#ccc)!important;cursor:pointer!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.7)!important;transition:border-color .16s ease,box-shadow .16s ease,transform .16s ease!important}',
      '#sticky-atc .sticky-atc-color-swatch:hover{border-color:rgba(5,6,9,.48)!important;transform:translateY(-1px)!important}',
      '#sticky-atc .sticky-atc-color-swatch.is-active{border-color:#050609!important;box-shadow:inset 0 0 0 3px #fff,0 0 0 1px #050609!important}',
      '#sticky-atc .sticky-atc-color-swatch:after{display:none!important}',
      '#sticky-atc .sticky-atc-color-swatch:focus-visible{outline:1px solid #050609!important;outline-offset:4px!important}',
      '#sticky-atc .sticky-atc-btn{height:46px!important;min-width:200px!important;padding:0 28px!important;border:1px solid #050609!important;border-radius:2px!important;background:#050609!important;color:#fff!important;font-family:acumin-pro,sans-serif!important;font-style:normal!important;font-size:12px!important;font-weight:400!important;line-height:1!important;letter-spacing:normal!important;text-transform:uppercase!important;box-shadow:none!important;transition:background .16s ease,color .16s ease,transform .16s ease!important}',
      '#sticky-atc .sticky-atc-btn:hover{background:#927f57!important;border-color:#927f57!important;transform:translateY(-1px)!important}',
      '@media(max-width:749px){#sticky-atc .sticky-atc-inner{min-height:78px!important;padding:8px 12px!important;gap:10px!important}#sticky-atc .sticky-atc-left{grid-template-columns:42px minmax(0,1fr)!important;gap:10px!important}#sticky-atc .sticky-atc-left img{width:42px!important;height:42px!important;border-radius:6px!important}#sticky-atc .sticky-atc-left>div{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"title" "variants"!important;row-gap:4px!important}#sticky-atc .sticky-atc-title{font-size:12px!important}#sticky-atc .sticky-atc-price{display:none!important}#sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"summary" "selector" "fit"!important;row-gap:2px!important;overflow:hidden!important}#sticky-atc .sticky-atc-selected-summary{font-size:10.5px!important;width:auto!important;min-width:0!important;max-width:168px!important;overflow:hidden!important;text-overflow:ellipsis!important}#sticky-atc .sticky-atc-selector-group{gap:6px!important}#sticky-atc .sticky-atc-fit-note{font-size:10px!important;max-width:168px!important;overflow:hidden!important;text-overflow:ellipsis!important}#sticky-atc .sticky-atc-color-picker{gap:6px!important}#sticky-atc .sticky-atc-color-swatch{width:22px!important;height:22px!important;min-width:22px!important;border-radius:5px!important}#sticky-atc .sticky-atc-btn{min-width:126px!important;height:42px!important;padding:0 14px!important;font-size:12px!important}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-inner{max-width:1180px!important;min-height:76px!important;padding:9px 24px!important;grid-template-columns:minmax(0,1fr) auto!important;gap:22px!important}',
      'html body #sticky-atc .sticky-atc-left{grid-template-columns:52px minmax(0,1fr)!important;gap:14px!important}',
      'html body #sticky-atc .sticky-atc-left img{width:52px!important;height:52px!important;border-radius:8px!important}',
      'html body #sticky-atc .sticky-atc-left>div,html body #sticky-atc .sticky-atc-copy{grid-template-columns:minmax(170px,235px) minmax(260px,380px)!important;grid-template-areas:"title variants"!important;align-items:center!important;column-gap:36px!important;row-gap:0!important}',
      'html body #sticky-atc .sticky-atc-action{display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:18px!important;white-space:nowrap!important}',
      'html body #sticky-atc .sticky-atc-price{display:block!important;font-size:14px!important;line-height:1!important;font-weight:400!important;color:rgba(5,6,9,.66)!important;margin:0!important}',
      'html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(96px,150px) auto!important;grid-template-areas:"summary selector" "fit selector"!important;align-items:center!important;column-gap:12px!important;row-gap:2px!important}',
      'html body #sticky-atc .sticky-atc-selected-summary{font-size:13px!important;line-height:1.15!important;color:#050609!important;width:auto!important;max-width:150px!important}',
      'html body #sticky-atc .sticky-atc-fit-note{font-size:10.5px!important;line-height:1.15!important;color:rgba(5,6,9,.52)!important;max-width:150px!important}',
      'html body #sticky-atc .sticky-atc-btn{min-width:184px!important;height:46px!important;padding:0 28px!important}',
      '@media(max-width:749px){html body #sticky-atc .sticky-atc-inner{min-height:70px!important;padding:8px 10px!important;grid-template-columns:minmax(0,1fr) auto!important;gap:10px!important}html body #sticky-atc .sticky-atc-left{grid-template-columns:40px minmax(0,1fr)!important;gap:10px!important}html body #sticky-atc .sticky-atc-left img{width:40px!important;height:40px!important;border-radius:6px!important}html body #sticky-atc .sticky-atc-left>div,html body #sticky-atc .sticky-atc-copy{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"title" "variants"!important;row-gap:3px!important}html body #sticky-atc .sticky-atc-title{font-size:12px!important}html body #sticky-atc .sticky-atc-action{gap:8px!important}html body #sticky-atc .sticky-atc-price{display:block!important;font-size:12px!important}html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"summary" "fit"!important;row-gap:1px!important}html body #sticky-atc .sticky-atc-selected-summary{font-size:10.5px!important;max-width:155px!important}html body #sticky-atc .sticky-atc-selector-group{display:none!important}html body #sticky-atc .sticky-atc-fit-note{font-size:10px!important;max-width:155px!important}html body #sticky-atc .sticky-atc-btn{min-width:108px!important;height:40px!important;padding:0 12px!important;font-size:12px!important}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-color-picker{gap:8px!important}',
      'html body #sticky-atc .sticky-atc-color-swatch{width:28px!important;height:28px!important;min-width:28px!important;border:2px solid #331f19!important;border-radius:1px!important;background-color:var(--bollide-sticky-swatch,#ccc)!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2280%22 height=%2280%22 viewBox=%220 0 80 80%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%22.58%22 numOctaves=%224%22 seed=%2211%22/%3E%3CfeColorMatrix type=%22saturate%22 values=%220%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%22.55%22/%3E%3C/svg%3E")!important;background-blend-mode:soft-light!important;box-shadow:inset 0 0 0 3px #fbfaf7!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Alabaster"]{border-color:#331f19!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Forest"]{border-color:#756519!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Noir"]{border-color:#111!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color="Midnight"]{border-color:#1d3057!important}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active{border-color:#050609!important;border-width:3px!important;box-shadow:inset 0 0 0 2px #fbfaf7!important}',
      '@media(max-width:749px){html body #sticky-atc .sticky-atc-variant-stack{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"selector"!important;row-gap:0!important}html body #sticky-atc .sticky-atc-selected-summary,html body #sticky-atc .sticky-atc-fit-note{display:none!important}html body #sticky-atc .sticky-atc-selector-group{display:flex!important;gap:6px!important}html body #sticky-atc .sticky-atc-color-picker{gap:6px!important}html body #sticky-atc .sticky-atc-color-swatch{width:22px!important;height:22px!important;min-width:22px!important;box-shadow:inset 0 0 0 2px #fbfaf7!important}html body #sticky-atc .sticky-atc-color-swatch.is-active{box-shadow:inset 0 0 0 1px #fbfaf7!important}}'
    ].join('\n');
    style.textContent += '\n' + [
      '@media(max-width:767px){',
      'html body #sticky-atc{padding-bottom:env(safe-area-inset-bottom)!important}',
      'html body #sticky-atc .sticky-atc-inner{box-sizing:border-box!important;min-height:88px!important;padding:8px 12px!important;display:grid!important;grid-template-columns:176px minmax(0,1fr)!important;grid-template-rows:18px 48px!important;grid-template-areas:"variants price" "variants button"!important;column-gap:8px!important;row-gap:6px!important;align-items:center!important}',
      'html body #sticky-atc .sticky-atc-left,html body #sticky-atc .sticky-atc-left>.sticky-atc-copy,html body #sticky-atc .sticky-atc-action{display:contents!important}',
      'html body #sticky-atc .sticky-atc-left img,html body #sticky-atc .sticky-atc-title{display:none!important}',
      'html body #sticky-atc .sticky-atc-variant-stack{grid-area:variants!important;display:grid!important;grid-template-columns:auto minmax(0,1fr)!important;grid-template-rows:18px 48px!important;grid-template-areas:"summary fit" "selector selector"!important;column-gap:6px!important;row-gap:6px!important;align-items:center!important;width:176px!important;max-width:176px!important;min-width:176px!important;margin:0!important;overflow:visible!important}',
      'html body #sticky-atc .sticky-atc-selected-summary{grid-area:summary!important;display:block!important;min-width:0!important;width:auto!important;max-width:none!important;margin:0!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;font-size:13px!important;line-height:18px!important;font-weight:600!important;color:#050609!important}',
      'html body #sticky-atc .sticky-atc-fit-note{grid-area:fit!important;display:block!important;min-width:0!important;max-width:none!important;margin:0!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;font-size:10.5px!important;line-height:14px!important;font-weight:400!important;color:rgba(5,6,9,.58)!important}',
      'html body #sticky-atc .sticky-atc-selector-group{grid-area:selector!important;display:block!important;width:176px!important;height:44px!important;min-width:176px!important;overflow:visible!important}',
      'html body #sticky-atc .sticky-atc-variant-row{display:contents!important}',
      'html body #sticky-atc .sticky-atc-color-picker{display:grid!important;grid-template-columns:repeat(4,44px)!important;gap:0!important;width:176px!important;height:44px!important;align-items:center!important}',
      'html body #sticky-atc .sticky-atc-color-swatch{position:relative!important;box-sizing:border-box!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:transparent!important;background-image:none!important;box-shadow:none!important;transform:none!important;cursor:pointer!important}',
      'html body #sticky-atc .sticky-atc-color-swatch:before{content:""!important;position:absolute!important;inset:4px!important;box-sizing:border-box!important;border:1px solid rgba(5,6,9,.24)!important;border-radius:1px!important;background-color:var(--bollide-sticky-swatch,#ccc)!important;background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2280%22 height=%2280%22 viewBox=%220 0 80 80%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%22.58%22 numOctaves=%224%22 seed=%2211%22/%3E%3CfeColorMatrix type=%22saturate%22 values=%220%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%22.55%22/%3E%3C/svg%3E")!important;background-blend-mode:soft-light!important;box-shadow:inset 0 0 0 2px #fbfaf7!important}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active{border:0!important;background:transparent!important;box-shadow:none!important}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active:before{box-shadow:inset 0 0 0 2px #fbfaf7,0 0 0 2px #050609!important}',
      'html body #sticky-atc .sticky-atc-color-swatch:focus-visible{outline:2px solid #050609!important;outline-offset:-3px!important}',
      'html body #sticky-atc [data-cart-errors-container]:empty{display:none!important}',
      'html body #sticky-atc [data-cart-errors-container]:not(:empty){grid-column:1/-1!important}',
      'html body #sticky-atc .sticky-atc-price{grid-area:price!important;display:block!important;align-self:center!important;justify-self:end!important;margin:0!important;font-size:14px!important;line-height:18px!important;font-weight:600!important;color:#050609!important}',
      'html body #sticky-atc .sticky-atc-btn{grid-area:button!important;box-sizing:border-box!important;align-self:center!important;justify-self:stretch!important;width:100%!important;min-width:0!important;height:48px!important;padding:0 10px!important;font-size:12px!important}',
      '}',
      '@media(max-width:339px){html body #sticky-atc .sticky-atc-inner{padding-left:8px!important;padding-right:8px!important}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc{box-sizing:border-box!important;background:#fbfaf7!important;border-top:1px solid rgba(51,31,25,.14)!important;border-radius:0!important;box-shadow:0 -8px 24px rgba(51,31,25,.06)!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important}',
      'html body #sticky-atc .sticky-atc-inner{border-radius:0!important}',
      'html body #sticky-atc .sticky-atc-title,html body #sticky-atc .sticky-atc-selected-summary{font-family:acumin-pro,sans-serif!important;font-weight:500!important;letter-spacing:.01em!important;color:#331f19!important}',
      'html body #sticky-atc .sticky-atc-fit-note{font-family:acumin-pro,sans-serif!important;font-weight:400!important;color:rgba(51,31,25,.56)!important}',
      'html body #sticky-atc .sticky-atc-fit-note strong{font-weight:500!important;color:rgba(51,31,25,.7)!important}',
      'html body #sticky-atc .sticky-atc-price{font-family:acumin-pro,sans-serif!important;font-weight:500!important;color:#331f19!important;font-variant-numeric:tabular-nums!important}',
      'html body #sticky-atc .sticky-atc-btn{position:relative!important;background:#331f19!important;border-color:#331f19!important;border-radius:1px!important;color:#fbfaf7!important;font-weight:500!important;letter-spacing:.08em!important;transform:none!important}',
      'html body #sticky-atc .sticky-atc-btn:hover{background:#4a342c!important;border-color:#4a342c!important;transform:none!important}',
      'html body #sticky-atc .sticky-atc-btn:active{background:#241613!important;border-color:#241613!important;transform:none!important}',
      'html body #sticky-atc .sticky-atc-btn.is-loading:disabled{opacity:1!important}',
      'html body #sticky-atc .sticky-atc-btn.is-loading [data-add-to-cart-text],html body #sticky-atc .sticky-atc-btn.is-success [data-add-to-cart-text]{visibility:hidden!important}',
      'html body #sticky-atc .sticky-atc-btn.is-loading:after,html body #sticky-atc .sticky-atc-btn.is-success:after{position:absolute!important;inset:0!important;display:grid!important;place-items:center!important;color:#fbfaf7!important;font:inherit!important;letter-spacing:.08em!important;text-transform:uppercase!important}',
      'html body #sticky-atc .sticky-atc-btn.is-loading:after{content:attr(data-loading-label)!important}',
      'html body #sticky-atc .sticky-atc-btn.is-success:after{content:attr(data-success-label)!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color]{border:1px solid rgba(51,31,25,.18)!important;box-shadow:inset 0 0 0 1px rgba(251,250,247,.82)!important;transform:none!important}',
      'html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color]:hover{border-color:rgba(51,31,25,.3)!important;transform:none!important}',
      'html body #sticky-atc .sticky-atc-color-swatch.is-active{border:1px solid rgba(51,31,25,.18)!important;box-shadow:inset 0 0 0 2px #fbfaf7,0 0 0 2px #331f19!important}',
      'html body #sticky-atc .sticky-atc-color-swatch:focus-visible{outline-color:#331f19!important}',
      '@media(max-width:767px){html body #sticky-atc{padding-left:env(safe-area-inset-left)!important;padding-right:env(safe-area-inset-right)!important}html body #sticky-atc .sticky-atc-color-swatch[data-sticky-color]{border:0!important;box-shadow:none!important}html body #sticky-atc .sticky-atc-color-swatch:before{border:1px solid rgba(51,31,25,.18)!important;box-shadow:inset 0 0 0 1px rgba(251,250,247,.82)!important}html body #sticky-atc .sticky-atc-color-swatch.is-active:before{border-color:rgba(51,31,25,.18)!important;box-shadow:inset 0 0 0 2px #fbfaf7,0 0 0 2px #331f19!important}}'
    ].join('\n');
    style.textContent += '\n' + [
      'html body #sticky-atc .sticky-atc-color-swatch.is-coming-soon:after{display:block!important;content:""!important;position:absolute!important;left:5px!important;right:5px!important;top:50%!important;height:1px!important;background:rgba(255,255,255,.92)!important;box-shadow:0 0 0 1px rgba(51,31,25,.24)!important;transform:rotate(-38deg)!important;pointer-events:none!important}',
      'html body #sticky-atc .sticky-atc-btn:disabled,html body #sticky-atc .sticky-atc-btn.is-coming-soon{background:#d8d5cf!important;border-color:#d8d5cf!important;color:rgba(51,31,25,.7)!important;cursor:not-allowed!important;transform:none!important;opacity:1!important}',
      '@media(max-width:767px){html body #sticky-atc .sticky-atc-selector-group{display:block!important;width:176px!important;max-width:176px!important;overflow-x:auto!important;overflow-y:hidden!important;overscroll-behavior-x:contain!important;scrollbar-width:none!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x!important}html body #sticky-atc .sticky-atc-selector-group::-webkit-scrollbar{display:none!important}html body #sticky-atc .sticky-atc-color-picker{display:flex!important;grid-template-columns:none!important;flex-wrap:nowrap!important;width:max-content!important;min-width:176px!important;height:44px!important;gap:0!important}html body #sticky-atc .sticky-atc-color-swatch{flex:0 0 44px!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important}}'
    ].join('\n');

    if (!style.isConnected) document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectLuxurySwatchStyles);
  } else {
    injectLuxurySwatchStyles();
  }
})();

(function () {
  'use strict';

  var CTA_TEXT = /\/products\/the-silk-lined-cotton-twill-hat(?:\/|$)/.test(window.location.pathname)
    ? 'Add to Bag'
    : 'Add to Bag';

  function isUnavailableText(value) {
    return /sold\s*out|unavailable|out\s*of\s*stock|coming\s*soon/i.test(String(value || ''));
  }

  function replaceFirstTextNode(root, text) {
    if (!root || isUnavailableText(root.textContent)) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          return node.nodeValue && node.nodeValue.trim()
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP;
        }
      }
    );

    var node = walker.nextNode();
    if (node) {
      node.nodeValue = text;
    } else {
      root.textContent = text;
    }
  }

  function updateCtaText() {
    document.querySelectorAll('[data-add-to-cart-text]').forEach(function (node) {
      if (node.closest('#sticky-atc') || node.closest('.prdrly_btn')) return;
      replaceFirstTextNode(node, CTA_TEXT);
    });

    document.querySelectorAll('button[name="add"], [data-add-to-cart], #sticky-atc-btn, .sticky-atc-btn').forEach(function (button) {
      if (!button || button.disabled || isUnavailableText(button.textContent)) return;
      if (button.closest('#sticky-atc') || button.matches('.prdrly_btn')) return;

      var nestedText = button.querySelector('[data-add-to-cart-text]');
      if (nestedText) {
        replaceFirstTextNode(nestedText, CTA_TEXT);
      } else {
        replaceFirstTextNode(button, CTA_TEXT);
      }
    });
  }

  function productForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return !(form.closest && form.closest('#sticky-atc'));
    }) || forms[0] || null;
  }

  function nativeAddButton(form) {
    if (!form) return null;

    var buttons = Array.prototype.slice.call(form.querySelectorAll('button[name="add"], [data-add-to-cart]'));
    return buttons.find(function (button) {
      return button && !(button.closest && button.closest('#sticky-atc')) && !button.disabled;
    }) || null;
  }

  function dispatchCartSignals(item) {
    var events = [
      'cart:refresh',
      'cart:updated',
      'cart:open',
      'theme:cart:reload',
      'theme:cart:open',
      'ajaxProduct:added'
    ];

    events.forEach(function (eventName) {
      try {
        document.dispatchEvent(new CustomEvent(eventName, {
          bubbles: true,
          detail: { item: item }
        }));
      } catch (error) {}
    });
  }

  function clickDrawerToggleIfSafe() {
    var selectors = [
      '[data-cart-drawer-open]',
      '[data-drawer-open="cart"]',
      '[data-drawer-open="drawer-cart"]',
      '[data-cart-toggle]',
      'button[aria-controls="CartDrawer"]',
      'button[aria-controls="cart-drawer"]',
      '.js-drawer-open-cart',
      'a[data-cart-drawer-toggle][href="/cart"]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var toggles = Array.prototype.slice.call(document.querySelectorAll(selectors[i]));
      var toggle = toggles.find(function (candidate) {
        return candidate && candidate.getClientRects().length > 0;
      });
      if (!toggle) continue;
      toggle.click();
      return true;
    }

    return false;
  }

  function fallbackAjaxAdd(form) {
    var formData = new FormData(form);
    var stickyErrors = document.querySelector('#sticky-atc [data-cart-errors-container]');

    if (stickyErrors) stickyErrors.textContent = '';

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add this item (' + response.status + ').');
        return response.json();
      })
      .then(function (item) {
        dispatchCartSignals(item);
        clickDrawerToggleIfSafe();
        updateCtaText();
      })
      .catch(function (error) {
        if (stickyErrors) stickyErrors.textContent = error.message || 'Unable to add this item.';
        updateCtaText();
      });
  }

  function nativeSubmitOrAjax(form) {
    if (!form) return;

    var nativeButton = nativeAddButton(form);
    if (nativeButton) {
      nativeButton.click();
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    var submitEvent = new Event('submit', {
      bubbles: true,
      cancelable: true
    });

    var notPrevented = form.dispatchEvent(submitEvent);
    if (notPrevented) {
      fallbackAjaxAdd(form);
    }
  }

  function attachStickyDrawerFlow() {
    var stickyButton = document.getElementById('sticky-atc-btn') || document.querySelector('#sticky-atc .sticky-atc-btn');

    if (!stickyButton) return;
    stickyButton.dataset.bollideDrawerAtc = 'true';

    if (window.BollideStickyDrawerCapture) return;
    window.BollideStickyDrawerCapture = true;

    function handleStickyAdd(event) {
      var clickedButton = event.target && event.target.closest
        ? event.target.closest('#sticky-atc-btn, #sticky-atc .sticky-atc-btn')
        : null;
      var form;

      if (!clickedButton || clickedButton.disabled || isUnavailableText(clickedButton.textContent)) return;

      if (clickedButton.dataset.bollideAdding === 'true') {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        return;
      }

      form = productForm();
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      clickedButton.dataset.bollideAdding = 'true';
      updateCtaText();
      nativeSubmitOrAjax(form);
      window.setTimeout(function () {
        delete clickedButton.dataset.bollideAdding;
      }, 1200);

      setTimeout(updateCtaText, 300);
      setTimeout(updateCtaText, 1000);
    }

    window.addEventListener('click', handleStickyAdd, true);
  }

  function schedule() {
    updateCtaText();
    attachStickyDrawerFlow();
    setTimeout(attachStickyDrawerFlow, 250);
    setTimeout(updateCtaText, 500);
    setTimeout(updateCtaText, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('variant:change', schedule, true);
  window.addEventListener('load', schedule);
})();

/* Sticky add to cart: compact bar, every color visible, price shown once (Sep 26).
   The layers above were sized for four colors. Phones got a 176px strip, so
   Charcoal, Merlot and Espresso scrolled out of view with no cue. Tablets got a
   fixed 380px column, so swatches slid under the Add to cart button (tapping
   one added the wrong color). The bar also showed the price twice.
   These rules load last and use a doubled id so they outrank the earlier
   layers. Phones get one compact row: color name over the swatches, with the
   button (price inside it) on the right. Tablets drop the product title to make
   room. The standalone price is hidden everywhere because the button carries it. */
(function () {
  'use strict';

  var STYLE_ID = 'bollide-sticky-atc-all-colors-css';
  var S = 'html body #sticky-atc#sticky-atc ';

  function rules() {
    return [
      S + '.sticky-atc-price{display:none!important}',
      S + '.sticky-atc-btn .bl-price{margin-left:.6em}',
      S + '[data-cart-errors-container]:empty{display:none!important}',
      '@media (max-width:767px){',
      S + '.sticky-atc-inner{min-height:0!important;padding:8px 12px!important;grid-template-columns:auto minmax(0,1fr) auto!important;grid-template-rows:16px 30px!important;grid-template-areas:"summary fit button" "selector selector button"!important;column-gap:8px!important;row-gap:4px!important;align-items:center!important}',
      S + '.sticky-atc-variant-stack{display:contents!important}',
      S + '.sticky-atc-selected-summary{grid-area:summary!important;align-self:center!important;max-width:none!important;font-size:13px!important;line-height:16px!important}',
      S + '.sticky-atc-fit-note{grid-area:fit!important;align-self:center!important;max-width:none!important;line-height:16px!important}',
      S + '.sticky-atc-selector-group{grid-area:selector!important;display:flex!important;align-items:center!important;width:auto!important;min-width:0!important;max-width:none!important;height:30px!important;margin-left:-3px!important;overflow:visible!important;touch-action:manipulation!important}',
      S + '.sticky-atc-color-picker{display:flex!important;flex:1 1 auto!important;flex-wrap:nowrap!important;justify-content:flex-start!important;width:100%!important;min-width:0!important;max-width:100%!important;height:30px!important;gap:0!important}',
      S + '.sticky-atc-color-swatch{flex:1 1 0!important;width:auto!important;min-width:0!important;max-width:36px!important;height:30px!important;min-height:30px!important}',
      S + '.sticky-atc-color-swatch:before{inset:auto!important;top:50%!important;left:50%!important;width:calc(min(100%, 30px) - 5px)!important;height:auto!important;aspect-ratio:1/1!important;transform:translate(-50%,-50%)!important}',
      '@supports not (aspect-ratio:1/1){' + S + '.sticky-atc-color-swatch:before{height:calc(min(100%, 30px) - 5px)!important}}',
      S + '.sticky-atc-btn{grid-area:button!important;align-self:center!important;width:auto!important;min-width:128px!important;height:46px!important;padding:0 14px!important}',
      'html body.template-product .needsclick[class*="kl-teaser-"]{bottom:calc(68px + env(safe-area-inset-bottom))!important}',
      '}',
      '@media (max-width:339px){' + S + '.sticky-atc-inner{padding-left:8px!important;padding-right:8px!important}}',
      '@media (min-width:768px){',
      S + '.sticky-atc-left>div,' + S + '.sticky-atc-copy{grid-template-columns:minmax(0,235px) auto!important;column-gap:28px!important}',
      S + '.sticky-atc-selector-group{min-width:max-content!important}',
      '}',
      '@media (min-width:768px) and (max-width:1023px){',
      S + '.sticky-atc-inner{padding-left:20px!important;padding-right:20px!important;gap:16px!important}',
      S + '.sticky-atc-title{display:none!important}',
      S + '.sticky-atc-left>div,' + S + '.sticky-atc-copy{grid-template-columns:minmax(0,1fr)!important;grid-template-areas:"variants"!important;column-gap:0!important}',
      S + '.sticky-atc-btn{min-width:164px!important;padding:0 20px!important}',
      '}'
    ].join('\n');
  }

  function stickyVariant() {
    var config = window.BOLLIDE_STICKY_ATC_PRODUCT || {};
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var input = document.querySelector('#sticky-atc form [name="id"]');
    var id = input ? String(input.value) : '';
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  /* One price, inside the button, set apart by space rather than a dot:
     "Preorder  $350" or "Add to cart  $350" (the price in a lighter span). */
  function priceInButton() {
    var button = document.querySelector('#sticky-atc .sticky-atc-btn');
    if (!button) return;
    var label = button.querySelector('[data-add-to-cart-text]') || button;
    var current = label.textContent.replace(/\s+/g, ' ').trim();
    var variant = stickyVariant();
    var price = variant && variant.priceText;
    var verb = /^preorder/i.test(current) ? 'Preorder' : (/^add to (cart|bag)/i.test(current) ? 'Add to Bag' : '');
    if (!verb || !price) { button.removeAttribute('aria-label'); return; }
    var want = verb + '<span class="bl-price" aria-hidden="true">' + price + '</span>';
    if (label.innerHTML !== want) label.innerHTML = want;
    button.setAttribute('aria-label', verb + ', ' + price);
  }

  function watchButton() {
    var button = document.querySelector('#sticky-atc .sticky-atc-btn');
    if (!button || button.getAttribute('data-bollide-price-cta')) return;
    button.setAttribute('data-bollide-price-cta', 'true');
    priceInButton();
    if (window.MutationObserver) {
      new MutationObserver(priceInButton).observe(button, { childList: true, characterData: true, subtree: true });
    }
  }

  function inject() {
    if (!document.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = rules();
      document.head.appendChild(style);
    }
    watchButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  window.addEventListener('load', priceInButton);
})();